/* global __webpack_public_path__ */
/* eslint-disable no-global-assign */

// Ensure Webpack loads async chunks from the top-level mount point (e.g. /patacat_complete)
(function configurePublicPath() {
  if (typeof window === 'undefined' || typeof __webpack_public_path__ === 'undefined') {
    return;
  }

  const segments = window.location.pathname.split('/').filter(Boolean);
  const mountSegment = segments.length > 0 ? `/${segments[0]}` : '';
  const normalized = mountSegment ? `${mountSegment}/` : '/';

  __webpack_public_path__ = normalized;
})();
